(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-index"] && !Shopify.designMode) return;
  try {
    
(function() {
  var grid = document.getElementById('piv-grid');
  if (!grid) return;


  var searchInput = document.getElementById('piv-search');
  var sortSelect  = document.getElementById('piv-sort');
  var tagSelect   = document.getElementById('piv-tag');


  function normalise(s){ return (s || '').toString().toLowerCase(); }


  function applyFilters() {
    var q   = normalise(searchInput ? searchInput.value : '');
    var tag = tagSelect ? normalise(tagSelect.value) : '';
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.piv-card'));


    cards.forEach(function(card){
      var title = normalise(card.getAttribute('data-title'));
      var tags  = normalise(card.getAttribute('data-tags'));
      var matchText = !q || title.indexOf(q) !== -1;
      var matchTag  = !tag || tags.indexOf(tag) !== -1;
      card.style.display = (matchText && matchTag) ? '' : 'none';
    });


    var sortVal = sortSelect ? sortSelect.value : 'newest';
    var visible = cards.filter(function(c){ return c.style.display !== 'none'; });


    visible.sort(function(a,b){
      if (sortVal === 'newest' || sortVal === 'oldest') {
        var da = new Date(a.getAttribute('data-date'));
        var db = new Date(b.getAttribute('data-date'));
        return sortVal === 'newest' ? (db - da) : (da - db);
      }
      var ta = a.getAttribute('data-title').toLowerCase();
      var tb = b.getAttribute('data-title').toLowerCase();
      if (sortVal === 'az') return ta.localeCompare(tb);
      if (sortVal === 'za') return tb.localeCompare(ta);
      return 0;
    });


    visible.forEach(function(card){ grid.appendChild(card); });
  }


  if (searchInput) searchInput.addEventListener('input', applyFilters);
  if (sortSelect)  sortSelect.addEventListener('change', applyFilters);
  if (tagSelect)   tagSelect.addEventListener('change', applyFilters);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  var grid = document.getElementById('piv-grid');
  if (!grid) return;

  var searchInput = document.getElementById('piv-search');
  var sortSelect  = document.getElementById('piv-sort');
  var tagSelect   = document.getElementById('piv-tag');

  function normalise(s){ return (s || '').toString().toLowerCase().trim(); }

  function getTags(card){
    var raw = card.getAttribute('data-tags') || '';
    var parts = raw.split('|');
    var out = [];
    for (var i = 0; i < parts.length; i++){
      var t = normalise(parts[i]);
      if (t) out.push(t);
    }
    return out;
  }

  function applyFilters() {
    var q   = normalise(searchInput ? searchInput.value : '');
    var tag = normalise(tagSelect ? tagSelect.value : '');

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.piv-card'));

    for (var i = 0; i < cards.length; i++){
      var card = cards[i];
      var title = normalise(card.getAttribute('data-title'));
      var tags  = getTags(card);

      var matchText = !q || title.indexOf(q) !== -1;
      var matchTag  = !tag || tags.indexOf(tag) !== -1;

      card.style.display = (matchText && matchTag) ? '' : 'none';
    }

    var sortVal = sortSelect ? sortSelect.value : 'newest';
    var visible = cards.filter(function(c){ return c.style.display !== 'none'; });

    visible.sort(function(a,b){
      if (sortVal === 'newest' || sortVal === 'oldest') {
        var da = new Date(a.getAttribute('data-date'));
        var db = new Date(b.getAttribute('data-date'));
        return sortVal === 'newest' ? (db - da) : (da - db);
      }
      var ta = (a.getAttribute('data-title') || '').toLowerCase();
      var tb = (b.getAttribute('data-title') || '').toLowerCase();
      if (sortVal === 'az') return ta.localeCompare(tb);
      if (sortVal === 'za') return tb.localeCompare(ta);
      return 0;
    });

    for (var j = 0; j < visible.length; j++){
      grid.appendChild(visible[j]);
    }
  }

  if (searchInput) searchInput.addEventListener('input', applyFilters);
  if (sortSelect)  sortSelect.addEventListener('change', applyFilters);
  if (tagSelect)   tagSelect.addEventListener('change', applyFilters);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piv-blog-index-paginated"] && !Shopify.designMode) return;
  try {
    
(function() {
  var grid = document.getElementById('piv-grid');
  if (!grid) return;

  var searchInput = document.getElementById('piv-search');
  var sortSelect  = document.getElementById('piv-sort');
  var tagSelect   = document.getElementById('piv-tag');

  function normalise(s){ return (s || '').toString().toLowerCase().trim(); }

  function getTags(card){
    var raw = card.getAttribute('data-tags') || '';
    var parts = raw.split('|');
    var out = [];
    for (var i = 0; i < parts.length; i++){
      var t = normalise(parts[i]);
      if (t) out.push(t);
    }
    return out;
  }

  function applyFilters() {
    var q   = normalise(searchInput ? searchInput.value : '');
    var tag = normalise(tagSelect ? tagSelect.value : '');

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.piv-card'));

    for (var i = 0; i < cards.length; i++){
      var card = cards[i];
      var title = normalise(card.getAttribute('data-title'));
      var tags  = getTags(card);

      var matchText = !q || title.indexOf(q) !== -1;
      var matchTag  = !tag || tags.indexOf(tag) !== -1;

      card.style.display = (matchText && matchTag) ? '' : 'none';
    }

    var sortVal = sortSelect ? sortSelect.value : 'newest';
    var visible = cards.filter(function(c){ return c.style.display !== 'none'; });

    visible.sort(function(a,b){
      if (sortVal === 'newest' || sortVal === 'oldest') {
        var da = new Date(a.getAttribute('data-date'));
        var db = new Date(b.getAttribute('data-date'));
        return sortVal === 'newest' ? (db - da) : (da - db);
      }
      var ta = (a.getAttribute('data-title') || '').toLowerCase();
      var tb = (b.getAttribute('data-title') || '').toLowerCase();
      if (sortVal === 'az') return ta.localeCompare(tb);
      if (sortVal === 'za') return tb.localeCompare(ta);
      return 0;
    });

    for (var j = 0; j < visible.length; j++){
      grid.appendChild(visible[j]);
    }
  }

  if (searchInput) searchInput.addEventListener('input', applyFilters);
  if (sortSelect)  sortSelect.addEventListener('change', applyFilters);
  if (tagSelect)   tagSelect.addEventListener('change', applyFilters);
})();

  } catch(e) { console.error(e); }
})();
})();
